export enum ScorecardActionType {
  marketplace = 220001,
  lotto = 200023,
  auction = 200025,
  polls = 200021,
  trivia = 200044,
  predictor = 200045,
  triviaGroup = 200047,
}
